import { render, staticRenderFns } from "./responsible-user-select.vue?vue&type=template&id=1eb8d878"
import script from "./responsible-user-select.vue?vue&type=script&lang=js"
export * from "./responsible-user-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb8d878')) {
      api.createRecord('1eb8d878', component.options)
    } else {
      api.reload('1eb8d878', component.options)
    }
    module.hot.accept("./responsible-user-select.vue?vue&type=template&id=1eb8d878", function () {
      api.rerender('1eb8d878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/leads/components/selects/responsible-user-select.vue"
export default component.exports